// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"PlanPage_faqContainer__McOPB"};